module.exports = __webpack_public_path__ + "static/media/no-list.67fada64.png";